import { TIMEZONES } from 'shared/mui/DatePicker/constants/timezones';

export const getTimezoneByName = (name?: string) => {
  return TIMEZONES.find((tz) => tz?.name === name);
};
